module.exports = __webpack_public_path__ + "static/montserrat-latin-600-6fb1b5623e528e27c18658fecf5ee0ee.woff2";